import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestExtractionsQueryKey } from "../bond-request.keys";

type UseFetchAdminBondRequestExtractionsParams = {
	accountId: SuretyAccountId;
	quoteId: SuretyQuoteId;
	enabled?: boolean;
};

export const useFetchAdminBondRequestExtractions = ({
	accountId,
	quoteId,
	enabled = true,
}: UseFetchAdminBondRequestExtractionsParams) => {
	const { get } = useRequest();

	const { data } = useQuery({
		queryKey: bondRequestExtractionsQueryKey(quoteId),
		queryFn: () =>
			get<Dtos.BondRequestExtraction.List.Response>(
				`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/bond-request-extractions`,
			),
		enabled,
	});

	return { extractions: data };
};
